"use client";

import { cn } from "@/lib/utils/cn";

export type SegmentedControlOption<T extends string = string> = { value: T; label: string; disabled?: boolean };
export type SegmentedControlProps<T extends string = string> = {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedControlOption<T>[];
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
};

export function SegmentedControl<T extends string>({ value, onChange, options, ariaLabel, className, disabled }: SegmentedControlProps<T>) {
  return (
    <div className={cn("segment-tabs inline-flex", className)} role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled || option.disabled}
            className={cn("segment-tab", active && "segment-tab-active")}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
